import { render, staticRenderFns } from "./DashboardSkills.vue?vue&type=template&id=0c1a50a9&scoped=true"
import script from "./DashboardSkills.vue?vue&type=script&lang=js"
export * from "./DashboardSkills.vue?vue&type=script&lang=js"
import style0 from "./DashboardSkills.vue?vue&type=style&index=0&id=0c1a50a9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1a50a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c1a50a9')) {
      api.createRecord('0c1a50a9', component.options)
    } else {
      api.reload('0c1a50a9', component.options)
    }
    module.hot.accept("./DashboardSkills.vue?vue&type=template&id=0c1a50a9&scoped=true", function () {
      api.rerender('0c1a50a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/dashboards/DashboardSkills.vue"
export default component.exports